// Home
<template>
  <div v-show="topShow" id="header" class="header">
    <div style="display: flex; align-items: center">
      <div style="margin-left: 58px" class="logo">
        <a href="javascript:void(0);"
          ><img src="../img/公司logo.png" alt=""
        /></a>
      </div>
      <div class="">
        <!-- <div class="n_icon" @click="toggleNav"></div> -->
        <ul @mouseleave="mouseLeave" style="display: flex">
          <li
            v-for="(item, index) in this.titleBox"
            :key="index"
            @mouseover="mouseOverList(item)"
            class="titleCss"
            :class="{ now: activeId == index }"
            @click="go(item)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
    <a href="javascript:void(0);" style="display: flex" @click="goChinese">
      <div class="Language">
        <img
          style="width: 30px; height: 30px"
          src="../img/语言切换.png"
          alt=""
        />Language
      </div>
    </a>
    <transition name="el-zoom-in-top">
      <!-- <transition name="nav-slide"> -->
      <div
        @mouseover="mouseOver2"
        @mouseleave="mouseLeave"
        v-if="isShow"
        class="MenuBar"
      >
        <!-- <div style="display: flex;"> -->
        <div class="leftCss">
          <div class="leftDiv">
            <ul>
              <li
                @mouseover.stop="mouseOver(item)"
                @mouseleave="mouseLeave2"
                @click="go(item)"
                v-for="(item, index) in leftBox"
                :key="index"
              >
                <a href="javascript:void(0);"> {{ item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="!DXALshow" class="rightCss">
          <div class="rightDiv">
            <ul>
              <a href="javascript:void(0);">
                <li
                  @mouseover.stop="mouseOver(item)"
                  v-for="(item, index) in this.rightBox"
                  :key="index"
                  @click="go(item)"
                >
                  {{ item.title }}
                </li></a
              >
            </ul>
          </div>
          <div class="fgx"></div>
          <div v-if="CPJSshow" class="rightImg">
            <div
              class="imgDIV"
              v-for="(item, index) in imgBox"
              :key="index"
              @click="go(item)"
            >
              <img
                style="width: 125px; height: 125px; cursor: pointer"
                :src="item.url"
                alt=""
              />
              <div
                style="
                  width: 125px;
                  height: 48px;
                  font-size: 18px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #000000;
                  text-align: center;
                "
              >
                {{ item.title }}
              </div>
            </div>
            <a class="imgDIV">
              <div
                @click="gochanping"
                style="
                  width: 125px;
                  height: 125px;
                  text-align: center;
                  cursor: pointer;
                "
              >
                <img
                  style="width: 30px; height: 6px; margin-top: 50%"
                  src="../img/产品查看更多.png"
                  alt=""
                />
              </div>

              <div
                style="
                  width: 125px;
                  height: 48px;
                  font-size: 18px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #000000;
                  text-align: center;
                "
              >
              See more
              </div>
            </a>
          </div>
          <div
            v-if="JJFAshow"
            style="width: 66%; display: flex; flex-direction: column"
          >
            <div
              style="
                padding: 4%;
                font-size: 18px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.6);;
                line-height: 36px;
                text-indent: 2em;
                height: 150px;
              "
            >
              <!-- aaaa -->
              {{ this.JJFAdata.title }}
            </div>
            <img class="jjfangantu" :src="this.JJFAdata.url" alt="" />
          </div>
        </div>

        <!-- 典型案例导航 -->
        <div v-if="DXALshow" class="rightCss">
          <div style="width: 100%; display: flex; flex-direction: column">
            <ul>
              <a>
                <li
                  style="
                    font-size: 18px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.6);
                    line-height: 36px;
                    text-align: end;
                    margin-left: 3%;
                    margin-right: 3%;
                    margin-top: 2%;
                  "
                  v-for="(item, index) in this.rightBox"
                  :key="index"
                  @click="go(item)"
                >
                  <a>{{ item.title }}</a>
                </li>
              </a>
            </ul>
            <img class="daohangxiaotu" :src="this.JJFAdata.url" alt="" />
          </div>
        </div>

        <!-- </div> -->
      </div>
    </transition>

    <!-- 右侧 -->
    <el-drawer
      size="70%"
      title=""
      :visible.sync="drawer"
      :before-close="handleClose"
    >
      <ul v-for="(item, index) in titleBox" :key="index">
        <li
          @click="go(item)"
          style="
            font-weight: bolder;
            margin-left: 3%;
            margin-right: 3%;
            font-size: 16px;
            padding: 15px 0;
            border-bottom: 1px solid #d4d4d4;
            line-height: 20px;
            color: #333333;
            font-size: 1em;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          "
        >
          <a href="javascript:void(0);"
            >{{ item.title }}
            <i style="float: right" class="el-icon-caret-right"></i>
          </a>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "MyHeader",
  data() {
    return {
      CPJSshow: false,
      JJFAshow: false,
      DXALshow: false,
      topShow: true,
      scrollTop: 0,
      drawer: false,
      timeoutId: null,
      isShow: false,
      leftBox: [],
      rightBox: [],
      JJFAdata: {
        title:
          "公司提供分布式光伏电站、集中式光伏电站、风光互补电站、风力发电站等新能源发电项目可研、方案、设计、设备选型采购、项目管理及施工、后期运维全生命周期的新能源发电服务。",
        url: require("../img/新能源.png"),
      },

      imgBox: [],
      activeId: "0",
      titleBox: [
        { title: "Home", router: "/En-US" },
        { title: "Product", router: "/Enproduct" },
        // { title: "产品资料", router: "/ziliao" },
        { title: "Solution", router: "/Ensolution" },
        { title: "Case", router: "/EntypicalCase" },
        { title: "News", router: "/EnNews" },
        { title: "E-Commerce", router: "" },
        { title: "About Us", router: "" },
        // { title: "联系我们", router: "/ContactUs" },
        // { title: "加入我们", router: "/joinUs" },
      ],
    };
  },
  methods: {
    handleScroll() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(this.scrollTop,'this.scrollTop');
      if (this.scrollTop > 250) {
        // 隐藏顶部导航栏
        this.topShow = false;
      } else {
        // 显示顶部导航栏
        // ...
        this.topShow = true;
      }
    },
    handleClose(done) {
      done();
    },
    mouseLeave2() {
      // this.rightBox=[]
    },
    mouseOver2() {
      clearTimeout(this.timeoutId);
      this.isShow = true;
    },
    // 鼠标移入
    mouseOver(val) {
      console.log(val, "vvvv");
      clearTimeout(this.timeoutId);
      // 产品方案一级
      if (val.title == "Stored Energy") {
        this.rightBox = [
          { title: "Household", router: "/Enproduct" },
          { title: "Portable", router: "/Enproduct" },
          { title: "Communication", router: "/Enproduct" },
          { title: "Industry and Commerce", router: "/Enproduct" },
          { title: "Centralized", router: "/Enproduct" },
        ];
        this.imgBox = [
          {
            title: "Single-phase hybrid inverter",
            url: require("@/views/product/img/单相2.png"),
            router: "/Enproduct",
          },
          {
            title: "Three-phase hybrid inverter",
            url: require("@/views/product/img/三相1.png"),
            router: "/Enproduct",
          },
          {
            title: "Low-voltage energy storage battery",
            url: require("@/views/product/img/低压电池1.png"),
            router: "/Enproduct",
          },
          {
            title: "High voltage energy storage battery",
            url: require("@/views/product/img/高压电池1.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Charging Pile") {
        this.rightBox = [
          { title: "Ac charging pile", router: "/Enproduct" },
          { title: "Dc charging pile", router: "/Enproduct" },
          // { title: "充电桩运营管理平台", router: "/product" },
        ];
        this.imgBox = [
          {
            title: "Wall type AC charging pile",
            url: require("@/views/product/img/交流壁挂.png"),
            router: "/Enproduct",
          },
          {
            title: "Column AC charging pile",
            url: require("@/views/product/img/落地式交流充电桩.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Intelligentize") {
        this.rightBox = [
          { title: "Entrance guard", router: "/Enproduct" },
          { title: "Smart parking", router: "/Enproduct" },
          { title: "Intelligent lighting", router: "/Enproduct" },
          { title: "Building control", router: "/Enproduct" },
          { title: "Energy management system", router: "/Enproduct" },
          { title: "Integrated management platform", router: "/Enproduct" },
          { title: "Multifunctional rod series products", router: "/Enproduct" },
        ];
        this.imgBox = [];
      } else if (val.title == "Smart energy") {
        this.rightBox = [
          { title: "New energy generation solutions", router: "/Ensolution" },
          { title: "Ensolution solutions", router: "/Ensolution" },
          { title: "Energy storage solution", router: "/Ensolution" },
        ];
      } else if (val.title == "Smart city") {
        this.rightBox = [
          { title: "Urban static traffic solutions", router: "/Ensolution" },
          { title: "Urban traffic management solutions", router: "/Ensolution" },
          { title: "Intelligent high-speed transportation solutions", router: "/Ensolution" },
        ];
      }
      //二级
      if (val.title == "Household") {
        this.imgBox = [
          {
            title: "Single-phase hybrid inverter",
            url: require("@/views/product/img/单相2.png"),
            router: "/Enproduct",
          },
          {
            title: "Three-phase hybrid inverter",
            url: require("@/views/product/img/三相1.png"),
            router: "/Enproduct",
          },
          {
            title: "Low-voltage energy storage battery",
            url: require("@/views/product/img/低压电池1.png"),
            router: "/Enproduct",
          },
          {
            title: "High voltage energy storage battery",
            url: require("@/views/product/img/高压电池1.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Portable") {
        this.imgBox = [
          {
            title: "600W portable power supply",
            url: require("@/views/product/img/600w户外.png"),
            router: "/Enproduct",
          },
          {
            title: "1200W portable power supply",
            url: require("@/views/product/img/1200w户外.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Communication") {
        this.imgBox = [
          {
            title: "Base station backup battery",
            url: require("@/views/product/img/通信储能.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Industry and Commerce") {
        this.imgBox = [
          {
            title: "Industrial and commercial energy storage - Air cooling",
            url: require("@/views/product/img/工商业储能-风冷.png"),
            router: "/Enproduct",
          },
          {
            title: "Industrial and commercial energy storage - liquid cooling",
            url: require("@/views/product/img/工商业储能-液冷.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Centralized") {
        this.imgBox = [
          {
            title: "Air-cooled energy storage system",
            url: require("@/views/product/img/集装箱储能.png"),
            router: "/Enproduct",
          },
          {
            title: "Liquid cooled energy storage system",
            url: require("@/views/product/img/液冷储能.png"),
            router: "/Enproduct",
          },
          {
            title: "Booster machine",
            url: require("@/views/product/img/升压一体机.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Ac charging pile") {
        this.imgBox = [
          {
            title: "Wall type AC charging pile",
            url: require("@/views/product/img/交流壁挂.png"),
            router: "/Enproduct",
          },
          {
            title: "Column AC charging pile",
            url: require("@/views/product/img/落地式交流充电桩.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "Dc charging pile") {
        this.imgBox = [
          {
            title: "200-360kW separate pile charging pile",
            url: require("@/views/product/img/200-360kW分体桩.png"),
            router: "/Enproduct",
          },
          {
            title: "480-600kW split charging pile",
            url: require("@/views/product/img/480-600kW分体式充电桩.png"),
            router: "/Enproduct",
          },
          {
            title: "Wall mounted DC charging pile",
            url: require("@/views/product/img/壁挂直流桩.png"),
            router: "/Enproduct",
          },
          {
            title: "Integrated DC charging pile",
            url: require("@/views/product/img/一体式直流桩02.47.png"),
            router: "/Enproduct",
          },
          {
            title: "High voltage liquid cooled charging pile",
            url: require("@/views/product/img/高压液冷.png"),
            router: "/Enproduct",
          },
        ];
      } else if (val.title == "充电桩运营管理平台") {
        this.imgBox = [
          {
            title: "充电桩运营管理平台",
            url: require("@/views/product/img/平台.png"),
          },
        ];
      } else if (val.title == "Made-in-China net") {
        this.JJFAdata = {
          title: "全系列产品，便捷购买，国内国际市场全覆盖。",
          url: require("../img/制造网.png"),
        };
      } else if (val.title == "Taobao") {
        this.JJFAdata = {
          title: "全系列产品，便捷购买，国内国际市场全覆盖。",
          url: require("../img/淘宝.png"),
        };
      } else if (val.title == "Smart city") {
        this.JJFAdata = {
          title:
            "The company provides the overall solution of the whole life cycle of intelligent projects such as design, equipment selection and procurement, project management and construction, and post-operation and maintenance of smart buildings, smart parks, and smart transportation.",
          url: require("../img/智慧城市.png"),
        };
      } else if (val.title == "Smart energy") {
        this.JJFAdata = {
          title:
            "The company provides new energy power generation services for the whole life cycle of distributed photovoltaic power station, centralized photovoltaic power station, wind-solar complementary power station, wind power station and other new energy power generation projects including research, scheme, design, equipment selection and procurement, project management and construction, and post-operation and maintenance.",
          url: require("../img/新能源.png"),
        };
      }
    },
    //导航栏移入
    mouseOverList(index) {
      clearTimeout(this.timeoutId);
      if (index.title == "Home") {
        this.isShow = false;
        this.leftBox = [];
        this.rightBox = [];
      } else if (index.title == "Product") {
        this.isShow = true;
        this.CPJSshow = true;
        this.JJFAshow = false;
        this.DXALshow = false;
        this.leftBox = [
          { title: "Stored Energy", router: "/Enproduct" },
          { title: "Charging Pile", router: "/Enproduct" },
          // { title: "Intelligentize", router: "/Enproduct" },
        ];
        this.rightBox = [
          { title: "Household", router: "/Enproduct" },
          { title: "Portable", router: "/Enproduct" },
          { title: "Communication", router: "/Enproduct" },
          { title: "Industry and Commerce", router: "/Enproduct" },
          { title: "Centralized", router: "/Enproduct" },
        ];
        this.imgBox = [
          {
            title: "Single-phase hybrid inverter",
            url: require("@/views/product/img/单相2.png"),
            router: "/Enproduct",
          },
          {
            title: "Three-phase hybrid inverter",
            url: require("@/views/product/img/三相1.png"),
            router: "/Enproduct",
          },
          {
            title: "Low-voltage energy storage battery",
            url: require("@/views/product/img/低压电池1.png"),
            router: "/Enproduct",
          },
          {
            title: "High voltage energy storage battery",
            url: require("@/views/product/img/高压电池1.png"),
            router: "/Enproduct",
          },
        ];
      } else if (index.title == "Solution") {
        this.isShow = true;
        this.JJFAshow = true;
        this.CPJSshow = false;
        this.DXALshow = false;
        this.leftBox = [
          { title: "Smart energy", router: "/Ensolution" },
          { title: "Smart city", router: "/Ensolution" },
        ];
        this.rightBox = [
          { title: "New energy generation solutions", router: "/Ensolution" },
          { title: "Ensolution solutions", router: "/Ensolution" },
          { title: "Energy storage solution", router: "/Ensolution" },
        ];
        this.JJFAdata = {
          title:
            "The company provides new energy power generation services for the whole life cycle of distributed photovoltaic power station, centralized photovoltaic power station, wind-solar complementary power station, wind power station and other new energy power generation projects including research, scheme, design, equipment selection and procurement, project management and construction, and post-operation and maintenance.",
          url: require("../img/新能源.png"),
        };
      } else if (index.title == "Case") {
        this.isShow = false;
        this.leftBox = [];
        this.rightBox = [];
        // this.isShow = true;
        // this.DXALshow = true;
        // this.JJFAshow = false;
        // this.CPJSshow = false;
        // this.leftBox = [
        //   { title: "智慧建筑典型案例", router: "/Building-case" },
        //   { title: "智慧能源典型案例", router: "/Energy-case" },
        //   { title: "智慧交通典型案例", router: "/Traffic-case" },
        // ];
        // this.rightBox = [
        //   { title: "枣庄双子星广场智慧楼宇" },
        //   { title: "横店街平安城镇/智慧社区及智能交通" },
        //   { title: "国网湖北计量中心泛在电力物联网系统及软件平台" },
        //   { title: "武汉舵落口广场" },
        //   { title: "中南设计研究总院有限公司设计大厦" },
        // ];
      } else if (index.title == "News") {
        this.isShow = false;
        this.leftBox = [];
        this.rightBox = [];
      } else if (index.title == "E-Commerce") {
        this.isShow = true;
        this.DXALshow = false;
        this.JJFAshow = true;
        this.CPJSshow = false;
        this.leftBox = [
          { title: "Made-in-China net", router: "" },
          { title: "Taobao", router: "" },
        ];
        this.rightBox = [];
        this.JJFAdata = {
          title: "Full range of products, easy to buy, full coverage of domestic and international markets.",
          url: require("../img/制造网.png"),
        };
      } else if (index.title == "About Us") {
        this.isShow = true;
        this.DXALshow = false;
        this.JJFAshow = true;
        this.CPJSshow = false;
        this.leftBox = [
          { title: "technical assistance", router: "/Enziliao" },
          { title: "Contact us", router: "/EnContactUs" },
          { title: "Join us", router: "/EnjoinUs" },
        ];
        this.rightBox = [];
        this.JJFAdata = {
          title:
            "As a national high-tech enterprise, the company always adheres to long-term layout, pursues excellence, enables high-quality development with continuous innovation, actively cultivates new generation information technologies such as artificial intelligence, big data, cloud computing, and blockchain, and becomes a leading product and solution provider in the field of smart energy and smart city.",
          url: require("../img/智慧城市.png"),
        };
      } else if (index.title == "产品资料") {
        this.isShow = false;
        this.leftBox = [];
        this.rightBox = [];
      } else if (index.title == "加入我们") {
        this.isShow = false;
        this.leftBox = [];
        this.rightBox = [];
      }
    },

    // 鼠标移出
    mouseLeave(val) {
      this.timeoutId = setTimeout(() => {
        this.isShow = false;
      }, 500); // 延迟500毫秒后隐藏导航栏
      // this.leftBox=[]
    },
    //路由跳转事件
    go(index) {
      this.$router.push(index.router);
      console.log(index);
      if (index.title == "Taobao") {
        window.open(
          "https://shop283530163.taobao.com/?spm=a230r.7195193.1997079397.2.294746bf338PI6",
          "_blank"
        );
      } else if (index.title == "Made-in-China net") {
        window.open("https://ffepower.en.made-in-china.com/", "_blank");
      }
    },
    gochanping() {
      this.$router.push("/Enproduct");
    },
    toggleNav() {
      // $(".nav ").slideToggle();
      this.drawer = true;
    },

    handleCommand(command) {
      if (command == "b") {
        this.$router.push("/En-US");
      }
    },
    goChinese() {
      this.$router.push("/home");
      document.title = '武汉烽火富华电气有限责任公司'
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>


<style scoped>
.titleCss {
  width: 200px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.titleCss {
  font-size: 20px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.8);
  line-height: 0px;
}
.titleCss:hover {
  color: #0940fd;
  border-bottom: 4px solid #0940fd;
}
.imgDIV {
  margin-left: 1%;
  margin-top: 2%;
}
.el-zoom-in-top-enter-active,
.el-zoom-in-top-leave-active {
  transition: transform 0.6s;
}

.el-zoom-in-top-enter,
.el-zoom-in-top-leave-to {
  opacity: 0;
}
.nav-slide-enter-active,
.nav-slide-leave-active {
  transition: transform 0.5s ease-in-out;
}

.nav-slide-enter,
.nav-slide-leave-to {
  transform: translateY(-100%);
}
::v-deep .head .logo img {
  width: 198px;
  height: 35.41px;
}
.Language {
  /* background: url("../img/语言切换.png") no-repeat; */
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  position: absolute;
  top: 32%;
  right: 3%;
  /* overflow-x: auto; */
}
@media screen and (max-width: 420px) {
  .Language {
    position: absolute;
    margin-top: -3%;
    margin-left: 1%;
  }
}
@media screen and (max-width: 780px) {
  .Language {
    position: absolute;
    margin-top: 0%;
    /* margin-top: 30px; */
    margin-left: 50%;
  }
  ::v-deep .head .logo img {
    width: 198px;
    height: 35.41px;
    vertical-align: top;
  }
}
@media screen and (max-width: 390px) {
  .Language {
    position: absolute;
    margin-top: 0%;
    margin-left: 50%;
  }
}
@media screen and (max-width: 330px) {
  .Language {
    position: absolute;
    margin-top: 0%;
    margin-left: 50%;
  }
}
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 60px;
  line-height: 45px;
  border-bottom: 2px solid transparent;
  color: #909399;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 18px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.header {
  width: 100%;
  height: 80px;
  position: fixed;
  z-index: 9999; /* 使导航栏处于最上层 */
  background-color: rgba(214, 208, 208, 0.3);
}
/* .nav_m {
  padding-left: 5%;
} */
.n_icon {
  right: 10%;
}

.li_color {
  color: orange;
}
.line {
  position: absolute;
  width: 1px;
  height: 260px;
  border-left: 1px solid #5f9edc;
  top: 10px;
  left: 25%;
}
.line4 {
  position: absolute;
  width: 1px;
  height: 180px;
  border-left: 1px solid #5f9edc;
  top: 10px;
  left: 25%;
}
.line2 {
  position: absolute;
  width: 1px;
  height: 260px;
  border-left: 1px solid #5f9edc;
  top: 10px;
  left: 50%;
}
.line3 {
  position: absolute;
  width: 1px;
  height: 260px;
  border-left: 1px solid #5f9edc;
  top: 10px;
  left: 75%;
}
.MenuBar {
  display: flex;
  /* margin-top: 0.5%; */
  margin-left: 16%;
  width: 68%;
  height: 546px;
}
@media screen and (max-width: 780px) {
  .MenuBar {
    display: none;
  }
}
.leftDiv {
  /* margin-left: 6%; */
}
.leftDiv li {
  padding: 7%;
  height: 78px;
  width: 100%;
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.leftDiv li:hover {
  /* margin-top: 10%;
  margin-right: 15%; */
  font-size: 18px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  background: #ffffff;
  border-radius: 12px 0px 0px 12px;
}
.leftDiv li a:hover {
  margin-top: 10%;
  margin-right: 15%;
  font-size: 18px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.rightDiv {
  width: 36.5%;
  /* margin-left: 10%; */
}
.fgx {
  margin-left: -2.5%;
  border-left: 1px solid #e0dcdc;
  height: 95%;
  margin-top: 2%;
  display: inline-block;
  vertical-align: middle;
}
.rightDiv ul {
  display: flex;
  flex-direction: column;
}
.leftDiv ul {
  display: flex;
  flex-direction: column;
}
.rightDiv li {
  font-weight: bolder;
  padding: 7%;
  height: 78px;
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.rightDiv li:hover {
  font-size: 18px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #0940fd;
}
.rightDiv li:hover::after {
  font-size: 18px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #0940fd;
  content: "";
  float: right;
  border-left: 5px solid #0940fd;
  height: 28px;
}

.rightDiv a:hover {
  font-size: 18px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #0940fd;
}
.leftCss {
  width: 26.7%;
  background-color: rgba(247, 249, 255, 1);
  border-radius: 12px 0px 0px 12px;
}

.rightCss {
  width: 73.3%;
  display: flex;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0px 12px 12px 0px;
}
.leftDiv li::after {
  content: "";
  float: right;
  background-image: url("../img/导航栏左侧箭头.png");
  display: block;
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
  margin-top: 4px;
}

.rightImg {
  /* margin: 7%; */
  width: 66%;
  display: flex;
  flex-wrap: wrap;
}
.daohangxiaotu {
  width: 267px;
  height: 162px;
  position: absolute;
  margin-top: 18%;
  margin-left: 34%;
  border-radius: 15px;
  cursor: pointer;
}
.jjfangantu {
  width: 267px;
  height: 162px;
  /* position: absolute; */
  margin-top: 30%;
  margin-left: 50%;
  margin-bottom: 46px;
  border-radius: 15px;
  cursor: pointer;
}
@media (min-width: 1020px) and (max-width: 1122px) {
  .head .nav li a {
    width: 78px;
    /* display: inline; */
  }
}
/*大于等于px，并且小于等于 px */
@media (min-width: 1480px) and (max-width: 1810px) {
  /* .titleCss {
    width: 140px;
    height: 80px;
    text-align: center;
  } */
  /* .jjfangantu {
    width: 267px;
    height: 162px;
    margin-top: 30%;
    margin-left: 30%;

    border-radius: 15px;
  } */
}
/*大于等于px，并且小于等于 px */
@media (min-width: 1308px) and (max-width: 1479px) {
  /* .titleCss {
    width: 110px;
    height: 80px;
    text-align: center;
  } */
  /* .jjfangantu {
    width: 267px;
    height: 162px;
    margin-top: 30%;
    margin-left: 30%;

    border-radius: 15px;
  } */
}
@media (min-width: 1025px) and (max-width: 1308px) {
  /* .titleCss {
    width: 100px;
    height: 80px;
    text-align: center;
  } */
}
@media (max-width: 1308px) {
  .Language {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    position: absolute;
    top: 39%;
    right: 5%;
  }
  .n_icon {
    right: 20%;
  }
}
@media (max-width: 770px) {
  .n_icon {
    right: 30%;
  }
}
</style>
